<script lang="ts" setup></script>

<template>
	<Head>
		<Title>Privacy Policy</Title>
	</Head>

	<main class="legal">
		<div class="content">
			<h1>Privacy Policy</h1>
			<p>
				This Privacy Policy outlines how we collect, use, and protect your personal information, covering our website mimicmo.com and its related services, as well as our mobile app "Mimicmo"
				available on the Apple App Store.
			</p>

			<h2>1. Information We Collect</h2>
			<p>We collect information from you in various ways, including:</p>

			<ul>
				<li>
					<strong>Personal Information:</strong>
					When you subscribe to our marketing emails on the website or through the Mimicmo app, we collect your email address.
				</li>

				<li>
					<strong>Automatically Collected Information:</strong>
					We may collect information about your device, browsing actions, and patterns automatically, both on our website and through the Mimicmo app. This information includes IP addresses,
					browser type, and operating system details.
				</li>
			</ul>

			<h2>2. How We Use Your Information</h2>
			<p>We use the information we collect for the following purposes:</p>

			<ul>
				<li>
					<strong>Marketing Communications:</strong>
					We use your email address to send you newsletters, promotional materials, and other marketing communications about our products, services, and events.
				</li>
				<li>
					<strong>App Functionality:</strong>
					The Mimicmo app may collect data to provide you with the features and services available within the app, such as user preferences and interactions.
				</li>
				<li>
					<strong>Improving Our Services:</strong>
					We analyze the information we collect to enhance our website, content, and services, as well as to improve the functionality and user experience of the Mimicmo app.
				</li>
			</ul>

			<h2>3. Disclosure of Your Information</h2>
			<p>
				We do not sell, trade, or otherwise transfer your personal information to third parties except as described in this Privacy Policy. Your information may be shared with trusted third
				parties who assist us in operating our website, conducting our business, or servicing you.
			</p>

			<h2>4. Your Choices</h2>
			<p>
				<strong>Marketing Communications:</strong>
				You may opt out of receiving marketing emails from us by following the unsubscribe instructions provided in each email. Please note that even if you opt out, we may still send you
				non-marketing emails related to your account or transactions.
			</p>

			<h2>Security</h2>

			<p>
				We take reasonable measures to protect the confidentiality and security of your personal information. However, no method of transmission over the Internet or electronic storage is
				completely secure. We cannot guarantee the absolute security of your information.
			</p>

			<h2>6. Cookies and Tracking Technologies</h2>
			<p>We may use cookies and similar tracking technologies on our website and within the Mimicmo app to collect information about your browsing and app usage activities.</p>

			<h2>7. Children's Privacy</h2>
			<p>Our website and the Mimicmo app are not directed to individuals under the age of 4, and we do not knowingly collect personal information from children under 4.</p>

			<h2>8. Apple App Store</h2>
			<p>
				The Mimicmo app available on the Apple App Store may require access to certain device permissions, such as camera or location services, to provide specific features. Please review and
				adjust your device settings to control these permissions.
			</p>

			<h2>9. Changes to This Privacy Policy</h2>
			<p>We may update this Privacy Policy to reflect changes in our practices and services. Any changes will be effective upon posting the updated policy on our website.</p>

			<h2>10. Contact Us</h2>
			<p>
				If you have any questions about this Privacy Policy or our practices, please contact us at
				<a href="mailto:support@mimicmo.com">contact@mimicmo.com</a>
				.
			</p>
		</div>
	</main>
</template>

<style scoped lang="scss"></style>
